/**
 * ForYouStyles.js
 *
 * Injects minimal CSS animations used by the ForYou flow.
 * - Heart beat
 * - Proposal float
 * - Sparkles
 */

import React from "react";

export default function ForYouStyles()
{
    return (
        <style>
            {`
                .heart-beat {
                    animation: heartBeat 1s infinite;
                    transform-origin: center;
                }

                @keyframes heartBeat {
                    0%   { transform: scale(1); }
                    14%  { transform: scale(1.12); }
                    28%  { transform: scale(1.02); }
                    42%  { transform: scale(1.16); }
                    70%  { transform: scale(1); }
                    100% { transform: scale(1); }
                }

                .proposal-float {
                    animation: floaty 2.4s ease-in-out infinite;
                }

                .proposal-float-2 {
                    animation: floaty 1.8s ease-in-out infinite;
                }

                @keyframes floaty {
                    0%   { transform: translateY(0px); }
                    50%  { transform: translateY(-6px); }
                    100% { transform: translateY(0px); }
                }

                .sparkle {
                    position: absolute;
                    font-size: 14px;
                    opacity: 0.9;
                    animation: sparkle 1.6s ease-in-out infinite;
                    user-select: none;
                }

                .sparkle-1 { top: -10px; left: -10px; animation-delay: 0s; }
                .sparkle-2 { top: -14px; right: -12px; animation-delay: 0.3s; }
                .sparkle-3 { bottom: -12px; left: 8px; animation-delay: 0.6s; }

                @keyframes sparkle {
                    0%   { transform: scale(0.9) rotate(0deg); opacity: 0.5; }
                    50%  { transform: scale(1.15) rotate(8deg); opacity: 1; }
                    100% { transform: scale(0.9) rotate(0deg); opacity: 0.6; }
                }
            `}
        </style>
    );
}